export default __webpack_public_path__ + "static/media/ECNY.7dedb506.svg";